import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  localitySearchTypeMunicipality: {
    id: 'locality.search.type.municipality',
    description: 'Locality search result type municipality',
    defaultMessage: 'Municipality',
  },
  localitySearchTypeMunicipalities: {
    id: 'locality.search.type.municipalities',
    description: 'Locality search result type municipalities',
    defaultMessage: 'Municipalities',
  },
  localitySearchTypeRegion: {
    id: 'locality.search.type.region',
    description: 'Locality search result type region',
    defaultMessage: 'Region',
  },
  localitySearchInputPlaceHolder: {
    id: 'locality.search.input.placeholder',
    description: 'Locality search box placeholder text',
    defaultMessage: 'Try search e.g. "Savonlinna"',
  },
  localitySearchHintMinimumLength: {
    id: 'locality.search.hint.minimum.length',
    description: 'Info for the minimum search length of 2 characters.',
    defaultMessage: 'Type at least 2 characters to search.',
  },
  localitySearchHintNoResults: {
    id: 'locality.search.hint.no.results',
    description: 'Info for no results.',
    defaultMessage: 'Nothing found with {searchString}...',
  }
});
